import axios from "@/plugins/axios";

const emptySaveData = {
  current_service: "",
  current_step: 1,
  is_service_activation: 0,
  scopeName: "",
};

// initial state
const state = () => ({
  currentScope: {},
  scopes: [],
  saveData: { ...emptySaveData },
  options: {},
  service: {},
  completed: false,
  started: false,
  loading: false,
  toasts: [],
  scopeSaveStates: [],
  wizard: {
    steps: {
      current: 1,
      total: 14,
    },
  },
});

const getters = {
  isCompleted: (state) => state.completed,
  isStarted: (state) => state.started,
  currentScope: (state) => state.currentScope,
  service: (state) => state.service,
  getToasts: (state) => state.toasts,
  hasUnsavedForm: (state) =>
    state.scopeSaveStates.findIndex((scope) => scope.state === false) !== -1,
  getWizardCurrentStep: (state) => state.wizard.steps.current,
  getWizardTotalSteps: (state) => state.wizard.steps.total,
};

const actions = {
  async getServiceData({ commit, state }, data) {
    try {
      const res = await axios.get("/api/rest/feature/activate/" + data.service + "/" + data.step);
      let redirect = "";
      if (res.data.status === "no-scopes") {
        redirect = res.data.service.code;
      } else {
        commit("setCurrentScope", res.data.scopes[parseInt(res.data.step) - 1]);
        commit("setScopes", res.data.scopes);
        commit("setCurrentService", res.data.service.code);
        commit("setCurrentStep", parseInt(res.data.step));
        commit("setService", res.data.service);
      }
      return redirect;
    } catch (err) {
      console.error(err);
    }
  },
  async save({ commit, state }, data) {
    //  data = {
    //    isActivation: Boolean, // maybe not needed
    //    scopes: [{
    //      name: String,
    //      data: [
    //          id: Int,
    //          value: Any
    //      ]
    //    }]
    //  }
    // needs better try-catch wrapping since 500 are not catched (?)
    try {
      for (let scope of data.scopes) {
        await axios.put(`/api/rest/profile/${scope.name}/store`, scope.data);
      }

      if (!state.saveData.is_service_activation) {
        commit("addToast", {
          message: "Profile updated!",
          title: "Success",
          variant: "success",
        });
      }

      if (state.saveData.current_step !== state.scopes.length) {
        let currentStep = state.saveData.current_step + 1;
        commit("setCurrentScope", state.scopes[state.saveData.current_step]);
        commit("setCurrentStep", currentStep);
      } else {
        commit("setCompleted", true);
      }
    } catch (err) {
      const errors = err.response.data;
      if (err.response.status === 422) {
        commit("addValidationErrorToast", errors);
      } else {
        commit("addErrorToast", errors);
      }
    }
  },
};

const mutations = {
  setCurrentScope(state, scope) {
    state.currentScope = scope;
  },
  setCurrentStep(state, step) {
    state.saveData.current_step = step;
  },
  setCompleted(state, completeState) {
    state.completed = completeState;
  },
  setStarted(state, startState) {
    state.started = startState;
  },
  setIsServiceActivation(state, activationState) {
    state.saveData.is_service_activation = activationState;
  },
  setScopeName(state, name) {
    state.saveData.scopeName = name;
  },
  setScopes(state, scopes) {
    state.scopes = scopes;
  },
  setCurrentService(state, currentService) {
    state.saveData.current_service = currentService;
  },
  setService(state, service) {
    state.service = service;
  },
  setWizardCurrentStep(state, step) {
    state.wizard.steps.current = step;
  },
  setWizardTotalSteps(state, step) {
    state.wizard.steps.total = step;
  },
  setScopeSaveStates(state, payload) {
    if (payload.length > 0) {
      state.scopeSaveStates = payload.map((v) => {
        return { code: v.code, state: true };
      });
    }
  },
  updateScopeSaveState(state, payload) {
    const index = state.scopeSaveStates.findIndex((scope) => scope.code === payload.identifier);
    if (index !== -1) {
      const newScope = { ...state.scopeSaveStates[index], state: payload.state };
      state.scopeSaveStates.splice(index, 1, newScope);
    }
  },
  resetActivation(state) {
    state.saveData = emptySaveData;
    state.started = false;
    state.completed = false;
  },
  addToast(state, payload) {
    state.toasts.push({
      message: payload.message,
      options: {
        title: payload.title ? payload.title : "Toast",
        variant: payload.variant ? payload.variant : "info",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
  addErrorToast(state, payload) {
    const message = payload.error;
    state.toasts.push({
      message: message,
      options: {
        title: "Error",
        variant: "danger",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
  addValidationErrorToast(state, payload) {
    const messages = Object.values(payload.error).flat().join("; ");
    state.toasts.push({
      message: messages,
      options: {
        title: "Error",
        variant: "danger",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
